import React from 'react';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';

const LOAN_STATES = [
	'ALL',
	'PENDING',

	// 'PROCESSED',
	// 'ACCEPTED',
	// 'DELETED',
	// 'APPROVE',
	// 'DECLINE',
	'FAILED',
	'SUCCESS'

	// 'POST_MODIFIED',
	// 'PRE_MODIFIED',
	// 'MODIFIED',
	// 'COMPLETED',
	// 'PAUSED',
	// 'PAYMENTS_STOPED',
	// 'DRAFTED'
];

const LOAN_STATES_FILTERED = [
	'ALL',
	'PENDING',
	'DECLINE',
	'DELETED',
	'APPROVE',
	'MODIFIED',
	'COMPLETED',
	'PAUSED'

	// "PROCESSED", //just to check transfer/outgoing fund
];

const INSTALLMENT = [
	'PAID'

	// "PROCESSED", //just to check transfer/outgoing fund
];

function Dropdown({ title = '', onChange = () => {}, value = {}, name = '', filterStatus = '', match }) {
	return (
		<>
			<div>
				<label htmlFor={title}>{title}</label>
				<select className="form-control" onChange={onChange} name={name} value={value}>
					{match.path === '/admin/customer/custom-view/:id' || filterStatus === ''
						? LOAN_STATES_FILTERED.map(m => (
								<option key={m} value={m}>
									{m}
								</option>
						  ))
						: filterStatus === 'incoming fund'
						? LOAN_STATES_FILTERED.map(m => (
								<option key={m} value={m}>
									{m}
								</option>
						  ))
						: filterStatus === 'outgoing fund'
						? INSTALLMENT.map(m => (
								<option key={m} value={m}>
									{m}
								</option>
						  ))
						: LOAN_STATES.map(m => (
								<option
									key={m}
									value={m}
									disabled={
										(filterStatus === 'top-up' && m === 'PENDING') ||
										filterStatus === 'ALL' ||
										m === 'SUCCESS' ||
										m === 'FAILED' ||
										m === 'ALL'
											? false
											: (filterStatus === 'cash-out' && m === 'PENDING') ||
											  m === 'SUCCESS' ||
											  m === 'FAILED' ||
											  m === 'ALL'
											? false
											: true
									}>
									{m}
								</option>
						  ))}
				</select>
			</div>
		</>
	);
}

export default withRouter(hot(module)(Dropdown));
